import React from 'react'
import { FormattedDate } from 'react-intl'
import { useParams, Link } from 'react-router-dom'
import { EmptyContainer, FadeIn, Spinner } from 'lib/ui'
import { MetaData } from 'components/MetaData'
import { NoMatch } from 'lib/shared/scenes/NoMatch'
import { useBlogPost } from 'hooks/blog'
import { Breadcrumbs } from 'components/Breadcrumbs'
import { CategoryList } from '../../components/CategoryList'
import { BlogLayout } from '../../components/BlogLayout'
import { Container } from './styled'

export const Post = () => {
  const params: any = useParams()
  const slug: string = params.slug
  const {
    title,
    content,
    publishDate,
    isFirstLoad,
    isFailure,
    tags,
    metaTitle,
    metaDescription
  } = useBlogPost(slug)

  if (isFailure) {
    return (
      <NoMatch />
    )
  }

  return (
    <>
      {isFirstLoad ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <>
          <Breadcrumbs
            title={title}
          />
          <BlogLayout>
            {(metaTitle ?? title) && (
              <MetaData
                title={metaTitle ?? title}
                description={metaDescription}
              />
            )}

            <FadeIn
              key={slug}
            >
              <Container>
                <div className='post-intro'>
                  {tags && tags?.length > 0 && (
                    <ul className='tags'>
                      {tags?.map((tag: any) => {
                        return (
                          <li key={tag.url_key}><Link to={`/blog/tag/${tag.url_key}`}>{tag.name}</Link></li>
                        )
                      })}
                    </ul>
                  )}
                  <h1>
                    {title}
                  </h1>
                </div>

                <div className='post-content'>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: content ?? ''
                    }}
                  />
                </div>

                <div className='post-extra'>
                  <div className='date'>
                    <FormattedDate
                      value={publishDate}
                      year='numeric'
                      month='long'
                      day='2-digit'
                    />
                  </div>
                </div>
              </Container>
            </FadeIn>
            <div>
              <CategoryList />
            </div>
          </BlogLayout>
        </>
      )}
    </>
  )
}
